import { createStyles, Link, makeStyles, Theme, Typography } from '@material-ui/core';
import CustomRouterLink from 'components/CustomRouterLink/CustomRouterLink';
import React from 'react';
import styles from 'assets/styles/default.scss';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    item: {
      maxWidth: '100%',
      fontFamily: '"Nunito", sans-serif',
      fontSize: 14,
      overflow: 'hidden',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    link: {
      color: styles.primarySicredi,
      fontWeight: 700
    },
    text: {
      color: styles.secondarySicrediDarker,
      fontWeight: 300,
    }
  }),
);

export interface IBreadCrumbItem {
  nome: string,
  url?: string,
}

export default ({ nome, url }: IBreadCrumbItem) => {
  const classes = useStyles();
  
  return url ? (
    <Link
      component={ CustomRouterLink }
      className={[classes.item, classes.link].join(' ')}
      to={ url }
    >
      { nome }
    </Link>
  ) : (
    <Typography
      component="label"
      className={[classes.item, classes.text].join(' ')}
    >
      { nome }
    </Typography> 
  )
}